// MUI Theme - standalone version for access-registration
import { createTheme } from '@mui/material/styles';
import { Colors, Spacing, fontFamily, fontStyles } from './theme';
import { BorisScreener } from './borisScreenerTheme';
import { convertHexToRgba } from '@/utils/colors';

export const MuiTheme = createTheme({
  palette: {
    primary: {
      main: BorisScreener.coral,
    },
  },
  typography: {
    fontFamily,
  },
  zIndex: {
    modal: 1200,
    drawer: 1400,
  },
  components: {
    MuiModal: {
      styleOverrides: {
        root: {
          overflowY: 'scroll',
          overflowX: 'hidden',
          overscrollBehaviorX: 'none',
          maxHeight: '100vh',
          maxWidth: '100vw',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          height: '4px',
          borderRadius: '4px',
          backgroundColor: Colors.foregroundDisabledAlt,
        },
        bar: {
          borderRadius: '4px',
        },
      },
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: convertHexToRgba(Colors.foreground, 0.75),
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: BorisScreener.coral,
          },
          color: Colors.foreground,
          flex: 1,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          '&.Mui-focused': {
            borderColor: BorisScreener.coral,
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: BorisScreener.coral,
            },
          },
        },
        notchedOutline: {
          fontSize: '18px',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          '&::placeholder': {
            fontSize: fontStyles.p1.fontSize,
            color: Colors.placeholder,
          },
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          paddingRight: `${Spacing.x3}px`,
          '&:last-child': {
            paddingBottom: `${Spacing.x2}px`,
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: '0px',
          height: '32px',
          width: '24px',
          '&:hover': {
            backgroundColor: 'transparent',
          },
          '&:focus': {
            backgroundColor: 'transparent',
          },
          '&:active': {
            backgroundColor: 'transparent',
            transition: 'none',
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          padding: '0px',
          height: '32px',
          width: '24px',
          '&:hover': {
            backgroundColor: 'transparent',
          },
          '&:focus': {
            backgroundColor: 'transparent',
          },
          '&:active': {
            backgroundColor: 'transparent',
            transition: 'none',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          pointerEvents: 'none',
          position: 'absolute',
          right: `${Spacing.x1_5}px`,
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: '-1',
          transition: 'transform 0.1s',
        },
        iconOpen: {
          transform: 'rotate(180deg) translateY(50%)',
        },
      },
    },
  },
});
